/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledModalBox } from './styles';
import InstructorNewEditForm from './InstructorNewEditForm';
import { InstructorType } from './types';

export const InstructorsModal = ({
  open,
  handleClose,
  isEdit,
  currentInstructor,
  getInstructorsList,
}: {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentInstructor: any | undefined;
  getInstructorsList: any;
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledModalBox>
        <InstructorNewEditForm
          isEdit={isEdit}
          currentInstructor={currentInstructor}
          getInstructorsList={getInstructorsList}
          handleClose={handleClose}
        />
      </StyledModalBox>
    </Modal>
  );
};
